import { CurrencyPipe } from '@angular/common';
import { computed, inject, Injectable, signal } from '@angular/core';
import { DsmStateService } from './dsm-state.service';

@Injectable({ providedIn: 'root' })
export class DsmCurrencyService {
  readonly #currencyPipe = new CurrencyPipe('en-US');
  readonly #state = inject(DsmStateService);

  readonly currencyCode = computed(() => this.#state.selectedCurrencyCode() ?? 'CAD');

  readonly currencySymbol = computed(() => {
    const code = this.currencyCode();
    return this.#getCurrencySymbol(code);
  });

  formatCurrency(value: number | string | null | undefined, digitsInfo = '1.2-2', currencyCode?: string): string {
    if (value === null || value === undefined || value === '') return '';

    const numericValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numericValue)) return '';

    const code = currencyCode ? currencyCode.toUpperCase() : this.currencyCode();
    return this.#currencyPipe.transform(numericValue, code, 'symbol', digitsInfo) ?? '';
  }

  getCurrencySymbolFromCode(code: string | null | undefined): string {
    if (!code) return this.currencySymbol();
    return this.#getCurrencySymbol(code.toUpperCase());
  }

  #getCurrencySymbol(code: string): string {
    try {
      const formatted = this.#currencyPipe.transform(0, code, 'symbol', '1.0-0');
      return formatted?.replace(/[^\p{Sc}]/gu, '').trim() || 'CA$';
    } catch {
      return 'CA$';
    }
  }
}
